export const LICENSE_ASSIGNMENT_FAILURE_TEXT =
  'License assignment failed. Please try again later.'
